import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import ContentLoader from "react-content-loader";
import { useSearchParams } from "react-router-dom";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import CategoriesProductsSlider from "../../components/categoriesProductsSlider";
import Filters from "../../components/categoryProducts/filters";
import UseGeneral from "../../hooks/useGeneral";
import "./style.css";
import { useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import { menueIcon, arrow_down } from "../../assets/svgIcons";
const CategoriesProducts = () => {
  const offlineCart = useSelector((state) => state.offlineCart);

  const userId = localStorage.getItem("green_trees");
  const user_id = userId && JSON.parse(userId);
  const { language } = UseGeneral();
  const [categoryId] = useSearchParams();

  const [categories, setCatgories] = useState([]);
  const [subCategories, setSubCategoires] = useState([]);
  const [category, setCategory] = useState("");
  const [pageLoading, setPageLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [filter, setFilter] = useState();
  const [ordersBy, setOrdersBy] = useState(null);
  const [moneyOrder, setMoneyOrder] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [subCategoryLoading, setSubCategoryLoading] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);
  const [noSubs, setNoSubs] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false);

  //
  const getProductBySelectedSubCategory = () => {
    setProductsLoading((prev) => true);
    setProducts((prev) => []);
    Axios({
      url:
        BASE_URL +
        `categories/get_product_by_category_id/${selectedSubCategory}`,
      method: "POST",
      data: {
        user_id,
        money_order: moneyOrder,
        order_by: ordersBy,
      },
    })
      .then((res) => {
        if (Array.isArray(res.result)) {
          setCatgories(res?.result);
          let prods = [...res.result];
          for (let k = 0; k < prods.length; k++) {
            for (let j = 0; j < offlineCart?.items.length; j++) {
              if (prods[k].id == offlineCart?.items[j]?.id) {
                prods[k].in_cart = 1;
                prods[k].quantity = offlineCart?.items[j].quantity;
              }
            }
          }
          setProducts((prev) =>
            res?.result?.filter((item) => item?.hidden == "0")
          );
        }
      })
      .finally(() => {
        if (subCategories && subCategories.length && selectedSubCategory) {
          setPageLoading(false);
          setProductsLoading(false);
        }
      })
      .catch((e) => console.log(e));
  };
  const getSubcategories = () => {
    setProducts((prev) => []);
    setPageLoading((prev) => true);
    // setSubCategoryLoading(true);
    Axios({
      url:
        BASE_URL + `categories/get_sub_by_cat_to_user/${categoryId.get("q")}`,
      method: "GET",
    })
      .then((res) => {
        if (Array.isArray(res.result)) {
          if (res?.result?.length > 0) {
            if (categoryId.get("s") == null) {
              setSelectedSubCategory((prev) => res.result[0].id);
            } else {
              setSelectedSubCategory(categoryId.get("s"));
            }
            setCategory(res.result[0]?.category || "");
          } else {
            setNoSubs(true);
          }
          setSubCategoires((prev) => res.result || []);
        }
      })
      .finally(() => {
        setSubCategoryLoading(false);
      })
      .catch((e) => console.log(e));
  };

  // useEffect(() => {
  //   setProducts((prev) => []);
  //   setProductsLoading((prev) => true);
  //   getProductBySelectedSubCategory();
  // }, [selectedSubCategory, categoryId.get("q")]);

  useEffect(() => {
    setProducts((prev) => []);
    setProductsLoading((prev) => true);
    getProductBySelectedSubCategory();
  }, [moneyOrder, ordersBy, selectedSubCategory]);

  useEffect(() => {
    setPageLoading((prev) => true);
    setProducts((prev) => []);
    setSelectedSubCategory((prev) => null);
    setSubCategoires((prev) => []);
    getSubcategories();
  }, [categoryId, categoryId.get("q"), categoryId.get("s")]);

  return (
    <>
      {pageLoading ? (
        <div
          style={{
            textAlign: "center",
            minHeight: "500px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ThreeDots />
        </div>
      ) : (
        <div style={{ padding: "20px 0" }}>
          {noSubs ? (
            <div className="no_subs">
              <img src={require("../../assets/images/no_image.png")} alt="" />
              <h5>
                {language == "ar"
                  ? "ما من فئات فرعيه هنا"
                  : "There Are Not Any Subcategory Here"}
              </h5>
            </div>
          ) : (
            <>
              <div className="categoy_subcats">
                {subCategoryLoading || pageLoading ? (
                  <ThreeDots />
                ) : subCategories && subCategories?.length ? (
                  <>
                    {/* <Filters
                      filtersData={subCategories}
                      filterChoosed={
                        subCategories.filter(
                          (item) => item.id == selectedSubCategory
                        )[0]
                      }
                      setFilter={setFilter}
                      language={language}
                      selectedCategory={selectedCategory}
                      setSelectedSubCategory={setSelectedSubCategory}
                      setSelectedCategory={setSelectedCategory}
                    /> */}
                  </>
                ) : null}
              </div>
              {pageLoading ? null : products && products?.length ? (
                <div className="product_filters">
                  <Dropdown
                    style={{ width: "fit-content" }}
                    className="order_by_product"
                  >
                    <Dropdown.Toggle
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        cursor: "pointer",
                        border: "none",
                      }}
                      variant=""
                      id="dropdown-basic"
                    >
                      <img src={require("../../assets/Layer 15.png")} alt="" />
                      <span>
                        {language == "ar" ? "ترتيب حسب:" : "Order By"}
                      </span>
                      <span>
                        {ordersBy == "best_seller"
                          ? language == "ar"
                            ? "الأكثر مبيعا"
                            : "Best Seller"
                          : language == "ar"
                          ? "وصل حديثا"
                          : "recently arrived"}
                      </span>
                      <img src={require("../../assets/Vector(1).png")} alt="" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      style={{
                        height: "50vh",
                        overflowY: "auto",
                        width: "400px",
                      }}
                    >
                      <div
                        onClick={() => {
                          setOrdersBy("best_seller");
                        }}
                        className="sel_one"
                      >
                        <div
                          className={
                            ordersBy == "best_seller"
                              ? "parent_div active"
                              : "parent_div"
                          }
                        >
                          <div className="child_div"></div>
                        </div>
                        <span>
                          {language == "ar" ? "الأكثر مبيعا" : "Best Seller"}
                        </span>
                      </div>
                      <div
                        onClick={() => {
                          setOrdersBy("recently_arived");
                        }}
                        className="sel_one"
                      >
                        <div
                          className={
                            ordersBy == "recently_arived"
                              ? "parent_div active"
                              : "parent_div"
                          }
                        >
                          <div className="child_div"></div>
                        </div>
                        <span>
                          {language == "ar" ? "وصل حديثا" : "recently arrived"}
                        </span>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>

                  <Dropdown
                    style={{ width: "fit-content" }}
                    className="order_by_product"
                  >
                    <Dropdown.Toggle
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        cursor: "pointer",
                        border: "none",
                      }}
                      variant=""
                      id="dropdown-basic"
                    >
                      <img src={require("../../assets/Layer 15.png")} alt="" />
                      <span>
                        {language == "ar" ? "ترتيب حسب:" : "Order By"}
                      </span>
                      <span>
                        {moneyOrder == "top_price"
                          ? language == "ar"
                            ? "الأكثر سعرا"
                            : "Top Price"
                          : language == "ar"
                          ? "الأقل سعر"
                          : "Few Price"}
                      </span>
                      <img src={require("../../assets/Vector(1).png")} alt="" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      style={{
                        height: "50vh",
                        overflowY: "auto",
                        width: "400px",
                      }}
                    >
                      <div
                        onClick={() => {
                          setMoneyOrder("top_price");
                        }}
                        className="sel_one"
                      >
                        <div
                          className={
                            moneyOrder == "top_price"
                              ? "parent_div active"
                              : "parent_div"
                          }
                        >
                          <div className="child_div"></div>
                        </div>
                        <span>
                          {language == "ar" ? "الأكثر سعر" : "Best Seller"}
                        </span>
                      </div>
                      <div
                        onClick={() => {
                          setMoneyOrder("few_price");
                        }}
                        className="sel_one"
                      >
                        <div
                          className={
                            moneyOrder == "few_price"
                              ? "parent_div active"
                              : "parent_div"
                          }
                        >
                          <div className="child_div"></div>
                        </div>
                        <span>
                          {language == "ar" ? "الأقل سعر" : "Few Price"}
                        </span>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              ) : null}
              {productsLoading ? (
                <div
                  style={{
                    textAlign: "center",
                    minHeight: "500px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ThreeDots />
                </div>
              ) : (
                <div className="cate_sub_prod">
                  <div className="cates_subs">
                    <div
                      onClick={() => setFiltersOpen(!filtersOpen)}
                      className="d-flex align-items-center justify-content-between"
                    >
                      <button
                        className={
                          false
                            ? "btn filterBtn category filtered"
                            : "filterBtn btn"
                        }
                        style={{ color: "green", fontWeight: "900" }}
                      >
                        {language == "ar"
                          ? category?.title_ar
                          : category?.title_en}
                      </button>

                      <div className="arrowIconfilter">{arrow_down}</div>
                    </div>
                    <div
                      className={`${
                        filtersOpen ? "open_filers" : "close_filters"
                      }`}
                    >
                      <Filters
                        filtersData={subCategories}
                        filterChoosed={
                          subCategories.filter(
                            (item) => item.id == selectedSubCategory
                          )[0]
                        }
                        setFilter={setFilter}
                        language={language}
                        selectedCategory={selectedCategory}
                        setSelectedSubCategory={setSelectedSubCategory}
                        setSelectedCategory={setSelectedCategory}
                      />
                    </div>
                  </div>
                  {/* here */}
                  <div className="cate_prods">
                    {products && products?.length > 0 ? (
                      <CategoriesProductsSlider
                        getData={getProductBySelectedSubCategory}
                        productsData={products}
                        language={language}
                      />
                    ) : (
                      <div
                        style={{
                          padding: "50px 20px",
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                          justifyContent: "center",
                          gap: "10px",
                        }}
                      >
                        {/* <img
                      src={require("../../assets/images/no_image.png")}
                      style={{ maxWidth: "250px" }}
                      alt=""
                    /> */}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default CategoriesProducts;
